import { connect } from 'react-redux';
import AdminFunds from '../components';

const mapStateToProps = state => ({
  literals: state.i18n.literals.funds,
  literalsCommon: state.i18n.literals.common,
  currency: state.global.currency,
});

export default connect(mapStateToProps)(AdminFunds);
